module.exports = __webpack_public_path__ + "img/marker.4004ce5.svg";